class RLM_ToggleText {
    constructor (content) {
        this.wrapper = content.parent();            
        this.initState();        
        this.initEvents();
    }

    initState () {
        this.isOpen = false;
        this.UI = {
            button: this.wrapper.find('.js-toggle-content-button'),
            content: this.wrapper.find('.js-toggle-content'),
            contentInner: this.wrapper.find('.js-toggle-content-inner')
        };
    }

    initEvents () {
        this.UI.button.on('click', (e) => {
            e.preventDefault();
            let initialHeight = jQuery(window).innerWidth() <= 560 ? this.UI.content.attr('data-height-mobile') : this.UI.content.attr('data-height-desktop');
            initialHeight = parseInt(initialHeight, 10);

            if (this.isOpen) {
                this.UI.content.css('height', this.UI.contentInner.outerHeight() + 'px');

                setTimeout(() => {
                    this.UI.content.removeClass('is-open');
                    this.isOpen = false;
                    this.UI.button.text(this.UI.button.attr('data-text-closed'));
                    this.UI.content.css('height', initialHeight + 'px');
                }, 0);

                setTimeout(() => {
                    this.UI.content.css('height', '');
                }, 350);
            } else {
                this.UI.content.css('height', initialHeight + 'px');

                setTimeout(() => {
                    this.UI.content.addClass('is-open');
                    this.UI.content.css('height', this.UI.contentInner.outerHeight() + 'px');
                    this.isOpen = true;
                    this.UI.button.text(this.UI.button.attr('data-text-open'));
                }, 0);

                setTimeout(() => {
                    this.UI.content.css('height', 'auto');
                }, 350);
            }
        });
    }
}

for (let i = 0; i < jQuery('.js-toggle-content').length; i++) {
    new RLM_ToggleText(jQuery('.js-toggle-content').eq(i));
}